module.exports = __webpack_public_path__ + "static/media/sg.b8d34582.svg";